import { render, staticRenderFns } from "./BranchesIcon.vue?vue&type=template&id=1dcd1ef9"
import script from "./BranchesIcon.vue?vue&type=script&lang=js"
export * from "./BranchesIcon.vue?vue&type=script&lang=js"
import style0 from "./BranchesIcon.vue?vue&type=style&index=0&id=1dcd1ef9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports